import {CurrentContactPersonDocument, CurrentOfficeDocument, CurrentOrgIdDocument, useCurrentContactPersonQuery, useCurrentOfficeQuery, useCurrentOrgIdQuery} from '../generated/graphql'

import type {ContactPersonFragment, CurrentContactPersonQuery, CurrentContactPersonQueryVariables, OfficeFragment, CurrentOfficeQuery, CurrentOfficeQueryVariables, CurrentOrgIdQuery, CurrentOrgIdQueryVariables} from '../generated/graphql'
import type {ApolloClient} from '@apollo/client'

export const useCurrentContactPerson = () => {
  const {data} = useCurrentContactPersonQuery({fetchPolicy: 'cache-only'})
  return data?.currentContactPerson ?? null
}
export const useCurrentOffice = () => {
  const {data} = useCurrentOfficeQuery({fetchPolicy: 'cache-only'})
  return data?.currentOffice ?? null
}

export const useCurrentOrgId = () => {
  const {data} = useCurrentOrgIdQuery({fetchPolicy: 'cache-only'})
  return data?.currentOrgId ?? null
}

export const setCurrentContactPerson = (
  client: ApolloClient<any>,
  currentContactPerson: ContactPersonFragment | null,
) => {
  client.writeQuery<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>({query: CurrentContactPersonDocument, data: {__typename: 'Query', currentContactPerson}})
}

export const setCurrentOffice = (
  client: ApolloClient<any>,
  currentOffice: OfficeFragment | null,
) => {
  client.writeQuery<CurrentOfficeQuery, CurrentOfficeQueryVariables>({query: CurrentOfficeDocument, data: {__typename: 'Query', currentOffice}})
}

export const setCurrentOrgId = (
  client: ApolloClient<any>,
  currentOrgId: string | null,
) => {
  client.writeQuery<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>({query: CurrentOrgIdDocument, data: {__typename: 'Query', currentOrgId}})
}